import { isString } from "@/common/general";
import { setBuffer } from "../interop/bufferManager";

// TODO: Consider maintaining aspect ratio
export function getSvgFromByteArray(byteArray: Uint8Array, width?: number, height?: number): Promise<number> {
  return new Promise<number>(resolve => {
    const jpgQuality = undefined;

    const decoder = new TextDecoder("utf-8");
    const svgText = decoder.decode(byteArray);

    const svgBlob = new Blob([svgText], { type: "image/svg+xml;charset=utf-8" });
    const uri = URL.createObjectURL(svgBlob);

    // load svg image into canvas
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = width && width > 0 ? width : image.width;
      canvas.height = height && height > 0 ? height : image.height;
      const context = canvas.getContext("2d");
      if (context) {
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const mimeType = jpgQuality ? "image/jpeg" : "image/png";
        canvas.toBlob(blob => {
          if (blob) {
            blob.arrayBuffer().then(buffer => resolve(setBuffer(buffer)), _ => resolve(0));
          } else {
            resolve(0);
          }
        }, mimeType, jpgQuality);
      }
    };
    image.onerror = error => {
      const errorMessage = isString(error) ? error : `${error.type}`;
      console.error(`Failed to load SVG for rasterization, ${errorMessage}`);
      resolve(0);
    };
    image.src = uri;
  });
}
